<template>
  <div class="d-flex flex-column justify-content-start gap-2">
    <fieldset>
      <div class="title bg-success">Alarmes</div>
      <div class="title subtitle">Whatsapp</div>
      <div class="mb-3">
          <label for="phone" class="col-form-label">Telefone de envio</label>
          <input :disabled="!isEditing.value" v-model="zabbix.phone" id="phone" class="form-control">
      </div>
      <div class="title subtitle">Gestor</div>
      <div class="mb-3">
          <label for="phone" class="col-form-label">Token da API</label>
            <input :disabled="!isEditing.value" v-model="zabbix.token" id="token" class="form-control">
      </div>
      <div class="title subtitle">Zabbix</div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="version" class="col-form-label">Versão</label>
            <select :disabled="!isEditing.value" v-model="zabbix.version" class="form-select"
              aria-label="Select version">
              <option disabled value="">Selecione uma versão</option>
              <option v-for="v in versionsArray" :key="v" :value="v">{{ v }}</option>
            </select>
          </div>

          <div class="mb-3">
            <label for="url" class="col-form-label">URL</label>
            <input :disabled="!isEditing.value" v-model="zabbix.url" id="url" type="url" class="form-control">
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label for="login" class="col-form-label">Login</label>
              <input :disabled="!isEditing.value" v-model="zabbix.login" id="login" class="form-control">
            </div>

            <div class="mb-3">
              <label for="password" class="col-form-label">Senha</label>
              <input :disabled="!isEditing.value" v-model="zabbix.password" id="password" type="password"
                class="form-control">
            </div>
          </div>
        </div>
      </div>
      <button v-if="isEditing.value" type="button" class="actions btn btn-success btn-sm" @click="saveZabbix">
        Salvar
      </button>
    </fieldset>

    <fieldset class="col-auto">
      <div class="title subtitle">Filtros</div>

      <div v-for="(filter, index) in zabbix.filters" :key="index" class="mb-3">
        <label for="token" class="col-form-label">Equipe</label>
        <div class="d-flex gap-3">
          <label v-if="zabbix.company.showService" class="form-check">
            <input :disabled="!isEditing.value" type="checkbox" class="form-check-input" value="atendimento"
              v-model="filter.showService" />
            Atendimento
          </label>

          <label v-if="zabbix.company.showMonitoring" class="form-check">
            <input :disabled="!isEditing.value" type="checkbox" class="form-check-input" value="monitoramento"
              v-model="filter.showMonitoring" />
            Monitoramento
          </label>
        </div>

        <label for="group" class="col-form-label">Grupo</label>
        <input :disabled="!isEditing.value" v-model="filter.group" class="form-control" placeholder="Grupo">

        <label for="host" class="col-form-label">Host</label>
        <input :disabled="!isEditing.value" v-model="filter.host" class="form-control" placeholder="Host">

        <label for="problem" class="col-form-label">Problema</label>
        <input :disabled="!isEditing.value" v-model="filter.problem" class="form-control" placeholder="Problema">

        <div class="form-group">
          <label class="col-form-label">Severidade</label>

          <div class="form-check">
            <input :disabled="!isEditing.value" class="form-check-input" type="checkbox" :value="0"
              v-model="filter.severity">
            <label class="form-check-label">Não classificado</label>
          </div>
          <div>
            <div class="form-check">
              <input :disabled="!isEditing.value" class="form-check-input" type="checkbox" :value="1"
                v-model="filter.severity">
              <label class="form-check-label">Informações</label>
            </div>
            <div class="form-check">
              <input :disabled="!isEditing.value" class="form-check-input" type="checkbox" :value="2"
                v-model="filter.severity">
              <label class="form-check-label">Aviso</label>
            </div>
            <div class="form-check">
              <input :disabled="!isEditing.value" class="form-check-input" type="checkbox" :value="3"
                v-model="filter.severity">
              <label class="form-check-label">Média</label>
            </div>
            <div class="form-check">
              <input :disabled="!isEditing.value" class="form-check-input" type="checkbox" :value="4"
                v-model="filter.severity">
              <label class="form-check-label">Alta</label>
            </div>
            <div class="form-check">
              <input :disabled="!isEditing.value" class="form-check-input" type="checkbox" :value="5"
                v-model="filter.severity">
              <label class="form-check-label">Desastre</label>
            </div>
          </div>
        </div>

        <button v-if="isEditing.value" type="button" class="btn btn-danger btn-sm" @click="() => filter.isDeleting = true">
          Remover
        </button>

        <ModalContent :is-modal-open="filter.isDeleting" @close="() => filter.isDeleting = false" @send="() => {
          deleteFilter(filter);
          filter.isDeleting = false
        }" :title="`Excluir filtro ?`">Você tem certeza que deseja excluir essa configuração de filtro ?
        </ModalContent>
      </div>
      <div v-if="isEditing.value" class="d-flex gap-2">
        <button type="button" class="btn btn-primary btn-sm" @click="addFilter">
          Adicionar
        </button>
        <button type="button" class="actions btn btn-success btn-sm" @click="updateFilters">
          Salvar
        </button>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { ZABBIX_VERSION } from "../../../../zabbix-shared/interfaces/intefaces";
import useEditMode from "@/services/EditingService";
import ModalContent from "@/components/ModalContent.vue";
import { zabbixFilterService, zabbixService } from "@/services/backend/ApiService";

export default {
  components: {
    ModalContent
  },
  data() {
    return {
      zabbix: {
        version: "",
        url: "",
        login: "",
        password: "",
        phone: "",
        token: "",
        filters: [],
        companyId: "",
      },
      versionsArray: ZABBIX_VERSION,
      currentZabbixId: null,
    };
  },
  setup() {
    const isEditing = useEditMode();

    return { isEditing };
  },
  methods: {
    async loadZabbixData(id) {
      try {
        this.zabbix = await zabbixService.findOne(id);
      } catch (error) {
        console.error("Erro ao carregar os dados do Zabbix:", error);
      }
    },
    async addFilter() {
      let newFilter = {
        zabbix: {
          id: this.zabbix.id
        },
      };

      newFilter = await zabbixFilterService.create(newFilter);
      newFilter.severity = [];
      if (!this.zabbix.filters) this.zabbix.filters = [];
      this.zabbix.filters.push(newFilter);
    },

    async deleteFilter(filter) {
      let response = await zabbixFilterService.delete(filter.id);
      this.zabbix.filters = this.zabbix.filters.filter( value => value.id != filter.id )
    },
    async updateFilters() {
      for (let filter of this.zabbix.filters) {
        await zabbixFilterService.update(filter.id, filter);
      }
    },
    async saveZabbix() {
      try {
        await zabbixService.update(this.zabbix.id, this.zabbix);
      } catch (error) {
        console.error("Erro ao salvar Zabbix:", error);
      }
    }
  },
  async mounted() {
    const zabbixId = this.$route.params.id;
    if (zabbixId) {
      await this.loadZabbixData(zabbixId);
    }
  }
};
</script>

<style scoped></style>
